import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppTopBar2 from "./common/app-top-bar2";
import AppLoading from "./common/app-loading";
import {
  Box,
  Card,
  Paper,
  Typography,
  Grid,
  Table,
  TableContainer,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import LinearProgress from "@mui/material/LinearProgress";
import { AppHelper } from "../AppHelper";
import SpaCheck from "./common/spa-check";
const dayjs = require("dayjs");

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Since 2020 all major browsers ensure sort stability with Array.prototype.sort().
// stableSort() brings sort stability to non-modern browsers (notably IE11). If you
// only support modern browsers you can replace stableSort(exampleArray, exampleComparator)
// with exampleArray.slice().sort(exampleComparator)
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCellsStu = [
  { id: "i", numeric: false, disablePadding: false, label: "" },
  { id: "studentName", numeric: false, disablePadding: false, label: "STUDENT NAME" },
  { id: "grade", numeric: false, disablePadding: false, label: "GRADE" },
  { id: "email", numeric: false, disablePadding: false, label: "EMAIL" },
  { id: "role", numeric: false, disablePadding: false, label: "ROLE" },
  { id: "tutor", numeric: false, disablePadding: false, label: "TUTOR" },
  {
    id: "tCodeLastLogin",
    numeric: false,
    disablePadding: false,
    label: "LAST LOGIN",
  },
];

function EnhancedTableHead(props) {
  const {
    order,
    orderBy,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  
   const headCells = headCellsStu;
      
  return (
    <TableHead>
      <TableRow>

        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export default function PageTutorInvite() {
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();

  const [isLoading, setIsLoading] = useState(true);
  
  const [stuList, setStuList] = useState([]);

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [tblOrderStu, setTblOrderStu] = React.useState("desc");
  const [tblOrderByStu, setTblOrderByStu] = React.useState("totalProfiles");
  const [filterTut, setFilterTut] = React.useState("");
  const [totalParent, setTotalParent] = useState(0);
  const [activeParent, setActiveParent] = useState(0);
  const [totalStudent, setTotalStudent] = useState(0);
  const [activeStudent, setActiveStudent] = useState(0);

  useEffect(() => {
    AppHelper.apiAuditPost("P-SA", "");
  }, []);

  useEffect(() => {
    if (!oUser) {
      navigate("/login");
      return;
    }
  });

  useEffect(() => {
    const fetchStudentParent = async () => {
        setIsLoading(true);
        var _res = await AppHelper.apiPost("api/account/list/tuitionStudent", {
        token: oUser.token,
        profileId: oUser.profileId,
    })
    if (!_res || !_res.status) {
        return;
    }

    _res.data.forEach((r, i) => {
      if (r.lastLogin) {
        var _ts = dayjs(r.lastLogin);
        r.lastLogin = _ts.format(`DD MMM 'YY hh:mm a`).toUpperCase(); //`Week ${_ts.week()} - ` +
        r.tCodeLastLogin = _ts.format("YYYYMMDDHHmmss");
      } else {
        r.lastLogin = "";
        r.tCodeLastLogin = "";
      }

      if (r.role == "Parent") {
        setTotalParent(prev => prev + 1);
        if (r.lastLogin) {
          setActiveParent(prev => prev + 1);
        }
      }
      if (r.role == "Student") {
        setTotalStudent(prev => prev + 1);
        if (r.lastLogin) {
          setActiveStudent(prev => prev + 1);
        }
      }
    });

    setStuList(_res.data);
    setIsLoading(false);
    }
    fetchStudentParent();
  }, []);

  const mobileOpenClick = (arg) => {
    setMobileOpen(!mobileOpen);
  };
  
  const listSortAndFilterStu = () => {
    var _list = [...stuList];
    if (filterTut && filterTut.length > 0) {
      var _filterText = filterTut.toLowerCase();
      _list = _list.filter((r) => r.email.toLowerCase().includes(_filterText));
    }
    return stableSort(_list, getComparator(tblOrderStu, tblOrderByStu));
  };
  
  const visibleStu = React.useMemo(
    () => listSortAndFilterStu(),
    [stuList, tblOrderStu, tblOrderByStu, filterTut]
  );

    const tblSortStu = (event, property) => {
        const isAsc = tblOrderByStu === property && tblOrderStu === "asc";
        setTblOrderStu(isAsc ? "desc" : "asc");
        setTblOrderByStu(property);
    };
  return (
    <>
    <Box sx={{ display: "flex" }}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
      {isLoading ? (
        <AppLoading />
      ) : (
        <>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: "100%",
              marginTop: "50px",
            }}
          >
                 
              <>
              <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="center"
                sx={{marginTop: '20px'}}
              >
                <Grid item sx={{marginRight: '5px'}}>
                  <Card
                    variant="outlined"
                    sx={{
                      padding: "10px 15px 10px 15px", 
                      marginBottom: '20px', 
                      borderRadius: '30px', 
                    }}
                  >
                    <div>Total Parent:  {totalParent}</div>
                    <div>Active Parent:  {activeParent}</div>
                  </Card>
                </Grid>
                <Grid item sx={{marginLeft: '5px'}}>
                  <Card
                    variant="outlined"
                    sx={{
                      padding: "10px 15px 10px 15px", 
                      marginBottom: '20px', 
                      borderRadius: '30px', 
                    }}
                  >
                    <div>Total Student:  {totalStudent}</div>
                    <div>Active Student:  {activeStudent}</div>
                  </Card>
                </Grid>
              </Grid>

                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <EnhancedTableHead
                      order={tblOrderStu}
                      orderBy={tblOrderByStu}
                      onRequestSort={tblSortStu}
                      gid="S1"
                      rowCount={stuList.length}
                    />
                    <TableBody>
                      {visibleStu.map((row, iTut) => (
                        <TableRow
                          key={row.profileId + row.name + row.tutor}
                          sx={{
                            
                          }}
                        >
                          <TableCell align="center">{iTut + 1}</TableCell>
                          <TableCell align="left">{row.studentName}</TableCell>
                          <TableCell align="left">{row.grade}</TableCell>
                          <TableCell align="left">{row.email}</TableCell>
                          <TableCell align="left">{row.role}</TableCell>
                          <TableCell align="left">{row.tutor}</TableCell>
                          <TableCell align="left">{row.lastLogin}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </>
            
          </Box>
        </>
      )}
      <SpaCheck></SpaCheck>
    </Box>
    </>
  );
}